<template>
  <div class="audience">
    <!-- Chats par agent -->
      <!-- <v-flex xs12>
        <v-card class="mb-3" height="400px" v-if="loadingAgentsChats">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
      </v-flex> -->
      
      <v-expansion-panel v-model="panel" expand>
      <!-- taux d'occupation par heure -->
      <!-- afficher uniquement si autorisé -->
      <v-expansion-panel-content>
        <div slot="header"><v-icon class="mr-2 primary--text">bar_chart</v-icon>{{ $t('statSuperv1')}}</div>
        <v-card>
          <v-layout row wrap>
          <!-- repartitions des chats -->
          <v-flex xs12 md4 >
            <v-card v-if="loadingAgentsChats" class="mb-3" height="360px">
              <v-card-text class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
            </v-card>
            <v-card v-else class="mb-3 text-md-center" height="360px">
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  flat
                  @click="exportAgentsChatsPie()"
                >
                  {{ $t('statSuperv3')}}
                  <v-icon color="primary" right>file_download</v-icon>
                </v-btn>
              </v-layout>
              <highcharts :options="agentsChatsPie"></highcharts>
            </v-card>
          </v-flex>

          <!-- Productivité -->
          <!-- afficher uniquement si autorisé -->
          <v-flex xs12 md4>
            <v-card v-if="loadingActivity" class="mb-3" height="360px">
              <v-card-text class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
            </v-card>
            <v-card v-else class="mb-3 text-md-center" height="360px">
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  flat
                  @click="exportProductivity()"
                >
                  {{ $t('statSuperv3')}}
                  <v-icon color="primary" right>file_download</v-icon>
                </v-btn>
              </v-layout>
              <highcharts :options="graphProductivityAgent"></highcharts>
              <span>{{ $t('connectionRate')}} : {{tauxProductivity1}} % ({{afficheTotalTempsConnexion}})</span><br />
              <span>{{ $t('agentsActivity')}} : {{tauxProductivity2}} % ({{afficheTotalTempsPresence}})</span><br />
              <span>{{ $t('agentsInactivity')}} : {{tauxProductivity3}} % ({{afficheTotalTempsHorsProd}})</span><br />
            </v-card>
          </v-flex>

          <!-- occupation conseillers -->
          <!-- afficher uniquement si autorisé -->
          <v-flex xs12 md4>
            <v-card v-if="loadingActivity" class="mb-3" height="360px">
              <v-card-text class="text-xs-center pt-5">
                <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
              </v-card-text>
            </v-card>
            <v-card v-else class="mb-3 text-md-center" height="360px">
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  dark
                  flat
                  @click="exportAgentsOccupation()"
                >
                  {{ $t('statSuperv3')}}
                  <v-icon color="primary" right>file_download</v-icon>
                </v-btn>
              </v-layout>
              <highcharts :options="activityAgent"></highcharts>
              <!-- <span>Temps d'activité : {{afficheTotalTempsPresence}}</span><br /> -->
              <!-- <span>{{ $t('maximumOccupancy')}} : {{afficheTotalTempsBusy}}</span><br /> -->
              <!-- <p class="text-md-center">Temps total en activité partielle : {{afficheTotalTempsPartielleActivity}}</p> -->
              <!-- <span>{{ $t('partialOccupation')}} : {{afficheTotalTempsPartielleChat}}</span><br /> -->
            </v-card>
          </v-flex>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    
      <!-- taux d'occupation par heure -->
      <!-- afficher uniquement si autorisé -->
      <v-expansion-panel-content>
        <div slot="header"><v-icon class="mr-2 primary--text">bar_chart</v-icon>{{ $t('statSuperv4')}}</div>
        <v-card v-if="loadingActivity" class="mb-3" height="360px">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
        <v-card v-else class="mb-3 text-md-center" height="360px">
          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="exportStatut()"
            >
              {{ $t('statSuperv3')}}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
          </v-layout>
          <highcharts :options="tauxActivityAgent"></highcharts>
        </v-card>
      </v-expansion-panel-content>

      <!-- nombre de chat par conseiller -->
      <!-- afficher uniquement si autorisé -->
      <v-expansion-panel-content>
        <div slot="header"><v-icon class="mr-2 primary--text">bar_chart</v-icon>{{ $t('statSuperv5')}}</div>
        <v-card v-if="loadingAgentsChats" class="mb-3" height="360px">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
        <v-card v-else class="mb-3 text-md-center" height="360px">
          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="exportAgentsChatsBar()"
            >
              {{ $t('statSuperv3')}}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
          </v-layout>
          <highcharts :options="agentsChatsBar"></highcharts>
        </v-card>
      </v-expansion-panel-content>

      <!-- Présence conseillers-->
      <!-- afficher uniquement si autorisé -->
      <v-expansion-panel-content>
        <div slot="header"><v-icon class="mr-2 primary--text">bar_chart</v-icon>{{ $t('statSuperv6')}}</div>
        <v-card v-if="loadingAgentsPresence" height="360px">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-layout row>
            <v-spacer></v-spacer>
            <!--
            <v-btn
              color="primary"
              dark
              flat
              @click="exportAgentsActivity()"
            >
              {{ $t('statSuperv3')}}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
            -->
          </v-layout>
          <highcharts :options="agentsPresence"></highcharts>
        </v-card>
      </v-expansion-panel-content>

      <!-- Taux d'activité -->
      <!--
      <v-expansion-panel-content >
        <div slot="header"><v-icon class="mr-2 primary--text">bar_chart</v-icon>Taux d'activité des conseillers</div>
        <v-card v-if="loadingAgentsActivity" height="360px">
          <v-card-text class="text-xs-center pt-5">
            <v-progress-circular indeterminate class="primary--text"></v-progress-circular>
          </v-card-text>
        </v-card>
        <v-card v-else>
          <v-layout row>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              flat
              @click="exportAgentsActivity()"
            >
              {{ $t('statSuperv3')}}
              <v-icon color="primary" right>file_download</v-icon>
            </v-btn>
          </v-layout>
          <highcharts :options="agentsActivity"></highcharts>
        </v-card>
      </v-expansion-panel-content>
      -->
    </v-expansion-panel>

    <!-- DIALOGUES OCCUPATION AGENT DAY-->
    <v-dialog
      v-model="occupationAgentDay"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      ref="dialogOccupation"
    >
      <wz-agents-occupation-day
         v-if="occupationAgentDay"
        :dataAgentSelected="dataAgentSelected"
        @closeDialog="dialogOccupationRemove"
      ></wz-agents-occupation-day>
    </v-dialog>

    <!-- DIALOGUES OCCUPATION AGENT PERIODE-->
    <v-dialog
      v-model="occupationAgentPeriode"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      ref="dialogOccupation"
    >
      <wz-agents-occupation-periode
         v-if="occupationAgentPeriode"
        :dataAgentSelected="dataAgentSelected"
        @closeDialog="dialogOccupationPeriodeRemove"
      ></wz-agents-occupation-periode>
    </v-dialog>

    <!-- DIALOGUES PRESENCE AGENT PERIODE-->
    <v-dialog
      v-model="presenceAgentsDay"
      persistent
      max-width="1200px"
      :scrollable="!$vuetify.breakpoint.smAndDown"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      ref="dialogPresence"
    >
      <wz-agents-presence-day
         v-if="presenceAgentsDay"
        :dataAgentsSelected="dataAgentsSelected"
        @closeDialog="dialogPresenceDayRemove"
      ></wz-agents-presence-day>
    </v-dialog>

  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import 'moment-duration-format'
import { mapGetters, mapState } from 'vuex'
import json2csv from 'json2csv'

export default {
  data () {
    return {
      // chats par agent
      loadingAgentsChats: true,
      occupationAgentDay: false,
      occupationAgentPeriode: false,
      presenceAgentsDay: false,
      loadingAgentsPresence: false,
      // taux d'activité
      loadingAgentsActivity: true,
      loadingActivity: true,
      loadingProductivity: true,
      dataAgentSelected: {agentID: ''},
      dataAgentsSelected: {agentID: '', agents: []},
      totalTempsPresence: 0,
      tempsTotalOnline: 0,
      tempsTotalBusy: 0,
      productivityAgent: 0,
      totalTempsConnexion: 0,
      tempsOccupationPartielle: 0,
      resAjx: null,
      tempsPresence: 8,
      totalTempsPeriode: 1,
      joursPeriode: 5,
      agents: [],
      agentsHeures: [],
      moyenChatHeure: [],
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,
      panel: [true, false],

      // options générales pour les graphiques
      optionsGraph: {
        // chart: {
        //   height: '350px'
        // },
        colors: [
          '#F44336', // red
          '#3F51B5', // indigo
          '#009688', // teal
          '#E91E63', // pink
          '#607D8B', // blue-grey
          '#9C27B0', // purple
          '#2196F3', // blue
          '#FF5722', // deep-orange
          '#795548', // brown
          '#4CAF50', // green
          '#8BC34A', // light-green
          '#673AB7', // deep-purple
          '#CDDC39', // lime
          '#03A9F4', // light-blue
          '#FFC107', // amber
          '#FF9800', // orange
          '#FFEB3B', // yellow
          '#00BCD4', // cyan
          '#9E9E9E'  // grey
        ],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        yAxis: [
        ],
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      // ------------------------------------------------
      // options pour le graphique des chats par agent
      // camembert
      // ------------------------------------------------
      agentsChatsPie: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: '300px'
        },
        title: {
          text: _.upperFirst(this.$t('chatsBetweenAgents'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {
                // ------------------------------------------------------------------------
                // momentanement commenté pour ne pas avoir acces au stats
                click: (e) => {
                  this.openOccupation(e)
                  // console.log('openOccupation =>', e)
                  // console.log('id agent', this.series.userOptions.agentID)
                }
                // ------------------------------------------------------------------------
              }
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      },

      // ------------------------------------------------------------------------
      // graphique activité
      // camembert
      activityAgent: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: '300px',
          type: 'pie'
        },
        title: {
          text: _.upperFirst(this.$t('advisorsOccupancy'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {
                // ------------------------------------------------------------------------
                // momentanement commenté pour ne pas avoir acces au stats
                // click: (e) => {
                //   this.openOccupation(e)
                  // console.log('date', this.category)
                  // console.log('id agent', e)
                // }
                // ------------------------------------------------------------------------
              }
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      },

      // ------------------------------------------------
      // histogramme
      // ------------------------------------------------
      agentsChatsBar: {
        chart: {
          type: 'column',
          height: '310px'
        },
        title: {
          text: _.upperFirst(this.$t('chatsPerAgents'))
        },
        subtitle: {
          text: this.$t('statSuperv7')
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            point: {
              events: {
                click: (e) => {
                  this.openDayOccupation(e)
                  console.log('openDayOccupation', e)
                  // console.log('id agent', this.series.userOptions.agentID)
                }
              }
            }
          }
        },
        xAxis: {
          categories: [] // dates de la période
        },
        yAxis: [
          { // petites valeurs entières
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {
                color: 'rgba(0, 0, 0, 1)'
              }
            },
            title: {
              text: 'Chats',
              style: {
                color: 'rgba(0, 0, 0, 1)'
              }
            },
            opposite: false
          }
        ],
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: <b>{point.y} / {point.stackTotal} chats</b>',
          borderColor: '#cccccc',
          crosshairs: true
        },
        series: [{}]
      },

      // ------------------------------------------------
      // options pour le graphique de la presence des conseillers
      // ------------------------------------------------
      agentsPresence: {
        chart: {
          height: '310px'
        },
        title: {
          // text: _.upperFirst(this.$t('agentsActivity'))
          text: this.$t('statSuperv8')
        },
        subtitle: {
          text: this.$t('statSuperv9')
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            events: {
              // ------------------------------------------------------------------------
              // momentanement commenté pour ne pas avoir acces au stats
              click: (e) => {
                this.openPresenceAgents(e)
                // console.log('presence', e)
                // console.log('id agent', this.series.userOptions.agentID)
              }
              // ------------------------------------------------------------------------
            }
          }
        },
        tooltip: {
          formatter: function () { // formatage de secondes à une durée en heures
            var s = '<b>' + this.x + '</b>'
            _.each(this.points, function (point) {
              s += '<br/><span style="color: ' + point.color + '">●</span> '
              s += point.series.name + ' : <b>' + point.y + '</b>'
            })
            return s
          },
          outside: true,
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // dates de la période
        },
        yAxis: [
          { // valeurs entières humanise les secondes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {color: '#607D8B'}
            },
            title: {
              text: this.$t('statSuperv11'),
              style: {color: '#607D8B'}
            },
            opposite: false
          },
          { // valeurs entières humanise les secondes
            allowDecimals: false,
            labels: {
              format: '{value}',
              style: {color: '#009688'}
            },
            title: {
              text: this.$t('statSuperv10'),
              style: {color: '#009688'}
            },
            opposite: true
          }, { // valeurs flotantes (pourcentage)
            allowDecimals: false,
            title: { text: '' },
            opposite: true
          }
        ],
        series: [
          {
            type: 'column',
            // color: '#009688', // teal
            // name: _.upperFirst(this.$t('timeOfPresence')),
            name: this.$t('statSuperv11'),
            yAxis: 0,
            data: [],
            dataAgents: [],
            zIndex: 3
          },
          {
            name: this.$t('trackedPages'),
            type: 'area',
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 1,
            data: [], // à remplir par l'appel ajax
            zIndex: 1,
            opacity: 0.5
          },
          {
            name: _.upperFirst(this.$tc('visitors', 2, { count: '' })),
            type: 'area',
            marker: {symbol: 'circle', enabled: false},
            visible: true,
            yAxis: 1,
            data: [], // à remplir par l'appel ajax
            zIndex: 2,
            opacity: 0.5
          }
        ]
      },

      // **************** A SUPPRIMER ***************** //
      // ------------------------------------------------
      // options pour le graphique du taux d'activité
      // ------------------------------------------------
      agentsActivity: {
        chart: {
          height: '310px',
          events: {
            // ------------------------------------------------------------------------
            // momentanement commenté pour ne pas avoir acces au stats
            click: (e) => {
              // this.openDayOccupation(e)
              // console.log('chat', e)
              // console.log('id agent', this.series.userOptions.agentID)
            }
            // ------------------------------------------------------------------------
          }
        },
        title: {
          text: _.upperFirst(this.$t('agentsActivity'))
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            events: {

            }
          }
        },
        tooltip: {
          formatter: function () { // formatage de secondes à une durée en heures
            var s = '<b>' + this.x + '</b>'
            _.each(this.points, function (point) {
              s += '<br/><span style="color: ' + point.color + '">●</span> '
              s += point.series.name + ': <b>'
              s += (point.colorIndex < 2)
              ? moment.duration(point.y, 'seconds').format('h [h] m [m] s [s]')
              : point.y + ' %'
              s += '</b>'
            })
            return s
          },
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] // dates de la période
        },
        yAxis: [
          { // valeurs entières humanise les secondes
            allowDecimals: false,
            title: { text: '' },
            opposite: false
          },
          { // valeurs entières humanise les secondes
            allowDecimals: false,
            title: { text: '' },
            opposite: false
          }, { // valeurs flotantes (pourcentage)
            allowDecimals: true,
            title: { text: '' },
            opposite: true,
            softMax: 100
          }
        ],
        series: [
          {
            type: 'column',
            name: _.upperFirst(this.$t('timeOfPresence')),
            yAxis: 1,
            data: []
          }, {
            type: 'column',
            name: _.upperFirst(this.$t('talkTime')),
            yAxis: 1,
            data: []
          }, {
            type: 'spline',
            name: _.upperFirst(this.$t('agentsActivity')),
            tooltip: { valueSuffix: ' %' },
            yAxis: 2,
            data: []
          }
        ]
      },

      // ------------------------------------------------
      // taux d'occupation agent par heure sur 24 heures
      // ------------------------------------------------
      tauxActivityAgent: {
        chart: {
          // type: 'column'
          // type: 'area',
          height: '310px'
        },
        title: {
          text: this.$t('statSuperv12')
        },
        subtitle: {
          text: this.$t('statSuperv13')
        },
        tooltip: {
          split: true,
          // shared: true,
          valueSuffix: ' %'
        },
        xAxis: {
          categories: ['00 h', '01 h', '02 h', '03 h', '04 h', '05 h', '06 h', '07 h', '08 h', '09 h', '10 h', '11 h', '12 h', '13 h', '14 h', '15 h', '16 h', '17 h', '18 h', '19 h', '20 h', '21 h', '22 h', '23 h'],
          // categories: ['00/01 h', '01/02 h', '02/03 h', '03/04 h', '04/05 h', '05/06 h', '06/07 h', '07/08 h', '08/09 h', '09/10 h', '10/11 h', '11/12 h', '12/13 h', '13/14 h', '14/15 h', '15/16 h', '16/17 h', '17/18 h', '18/19 h', '19/20 h', '20/21 h', '21/22 h', '22/23 h', '23/00 h'],
          title: {
            text: this.$t('statSuperv14')
          }
          // pas mal pour visualiser la période de travail
          // plotBands: [{
          //   from: 4.5,
          //   to: 6.5,
          //   color: 'rgba(68, 170, 213, .2)'
          // }]
        },
        yAxis: [
          {
            min: 0,
            max: 100,
            title: {
              text: this.$t('statSuperv15')
            },
            labels: {
              formatter: function () {
                return this.value + ' %'
              }
            }
          },
          {
            min: 0,
            title: {
              text: this.$t('statSuperv16'),
              style: {
                color: this.Highcharts.getOptions().colors[0]
              }
            },
            labels: {
              // formatter: function () {
              //   return this.value + ' Sollicitations visiteurs'
              // }
              format: '{value} ',
              style: {
                color: this.Highcharts.getOptions().colors[0]
              }
            },
            opposite: true
          }
        ],
        plotOptions: {
          // column: {
          //   stacking: 'normal'
          // }
          // column: {
          //   stacking: 'percent'
          // }
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          },
          line: {
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 4
              }
            },
            marker: {
              enabled: false
            }
          }
        },
        series: []
      },

      // graphique activité
      // camembert
      graphProductivityAgent: {
        chart: {
          type: 'solidgauge',
          height: '250px',
          events: {
            // render: this.renderGraph()
          }
        },

        title: {
          text: _.upperFirst(this.$t('productivity'))
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          useHTML: true,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div style="text-align: center;"><div style="font-size:0.7em; width:100%">{series.name}</div><div style="font-size:1.15em; color: {point.color}; font-weight: bold; width:100%">{point.y}%</div></div>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: (this.chart.plotHeight / 2) + 15
            }
          },
          shared: true
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{ // Track for Move
            outerRadius: '112%',
            innerRadius: '88%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#3F51B5')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Exercise
            outerRadius: '87%',
            innerRadius: '63%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#8BC34A')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }, { // Track for Stand
            outerRadius: '62%',
            innerRadius: '38%',
            // backgroundColor: '#3F51B5',
            backgroundColor: this.Highcharts.Color('#9E9E9E')
              .setOpacity(0.3)
              .get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: _.upperFirst(this.$t('connected')),
          data: [{
            color: '#3F51B5',
            // color: this.Highcharts.getOptions().colors[0],
            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: _.upperFirst(this.$t('emojiActivity')),
          data: [{
            color: '#8BC34A',
            // color: this.Highcharts.getOptions().colors[1],
            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: _.upperFirst(this.$t('inactivity')),
          data: [{
            color: '#9E9E9E',
            // color: this.Highcharts.getOptions().colors[2],
            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      }
    }
  },

  created () {
    // console.log('created')
    // recupère les données de tous les agents
    this.axios.get('get/agents.php')
    .then(response => {
      this.resAjx = response.data
      this.init()
    })
    .catch()
    .then(_ => {
      // this.loading = false
    })
  },

  mounted () {
    // console.log('mounted')
    // affichage des loaders
    this.loadingAgentsChats = true
    this.loadingAgentsPresence = true
    this.loadingAgentsActivity = true
    // initialisation des options liées aux graphiques
    this.agentsChatsPie = _.merge(this.agentsChatsPie, this.optionsGraph)
    this.agentsChatsBar = _.merge(this.agentsChatsBar, this.optionsGraph)
    // this.agentsActivity = _.merge(this.agentsActivity, this.optionsGraph)
    this.tauxActivityAgent = _.merge(this.tauxActivityAgent, this.optionsGraph)
    this.agentsPresence = _.merge(this.agentsPresence, this.optionsGraph)
    this.activityAgent = _.merge(this.activityAgent, this.optionsGraph)
    // this.graphProductivityAgent = _.merge(this.graphProductivityAgent, this.optionsGraph)
    // this.getAll()
    // const _self = this
  },

  computed: {
    ...mapGetters('_Stats', ['params', 'GET_DATESTART', 'GET_DATEEND']),
    ...mapState('_User', ['brides']),
    agentsChatsPieComputed () {
      // console.log('tot', this.agentsChatsPie.series[0].data)
      let res = []
      _.each(this.agentsChatsPie.series[0].data, a => {
        // console.log('a', a)
        let name = a.name
        let chats = a.chats
        res.push({
          name: name,
          y: a.y,
          chats: chats
        })
      })
      return res
    },
    // Calcule le taux d'occupation busy
    // temps de presence agent uniquement busy
    tauxBusy () {
      return (this.tempsTotalBusy * 100) / this.totalTempsConnexion
    },
    // Calcule le taux d'occupation partirel, 1chat mini et pas au max des chat
    // le temps de presence agent uniquement si en chat et pas busy
    tauxOccupationPartiel () {
      return (this.tempsOccupationPartielle * 100) / this.totalTempsConnexion
    },
    // Calcule le taux d'inoccupation pas en chat et online
    // le temps de presence agent (online + busy) - (temps partiel en chat + temps busy)
    tauxInoccupation () {
      let inoccuper = this.totalTempsPresence - (this.tempsTotalBusy + this.tempsOccupationPartielle)
      // let inoccuper = (this.totalTempsConnexion - (this.tempsOccupationPartielle + this.tempsOccupationBusy))
      return ((inoccuper) * 100) / this.totalTempsConnexion
    },
    // affiche le temps total connecté au bo
    afficheTotalTempsConnexion () {
      return moment.duration((this.totalTempsConnexion / 60), 'minutes').format('h [h] m [min]')
    },
    // affiche le temps de presence agent (online + busy)
    afficheTotalTempsPresence () {
      let tempsPresence = this.totalTempsPresence
      return moment.duration((tempsPresence / 60), this.$t('statSuperv17')).format('h [h] m [min]')
    },
    // affiche le temps hors production
    afficheTotalTempsHorsProd () {
      let tempsHorsProd = (this.totalTempsConnexion - (this.tempsTotalBusy + this.tempsTotalOnline))
      return moment.duration((tempsHorsProd / 60), this.$t('statSuperv17')).format('h [h] m [min]')
    }
  },

  methods: {
    // recupere la liste de tous les agents dispo avec leur temps de travail
    init () {
      // console.log('init', this.resAjx)
      for (var id in this.resAjx) {
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: _.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          rights: _.toInteger(this.resAjx[id][0].USR_RIGHTS),
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          joursHebdo: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT
        })
      }
      this.periodeConnexion()
      // console.log('this.agents', this.agents)
    },

    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },

    /**
     * lance toutes les requêtes
     */
    getAll () {
      // console.log('getAll')
      this.loadingActivity = true
      // console.log('getAll')
      this.getAgentsChats()
      // this.getAgentsActivity()
      this.getAgentsPresence()
      this.calculPeriodeConnexion()
      this.getAgentsOccupation()
    },

    // calcul la période de connexion et affiche les graphiques
    periodeConnexion () {
      this.calculPeriodeConnexion()
      this.getAll()
    },

    // calcule le temps total de l'activité de tous les agents selectionné
    calculPeriodeConnexion () {
      // console.log('calculPeriodeConnexion')
      // encodage à remplacer
      let deuxPoints = /%3A/gi
      let plus = /%2B/gi
      // decoupe les params pour recuperer uniquement les dates
      // date de debut
      let arraydata = this.params.split('dateStart=')
      let arrayDate2 = arraydata[1].split('&')
      let dateStartEncoded = arrayDate2[0]
      // date de fin
      let arraydata3 = this.params.split('dateEnd=')
      let arrayDate4 = arraydata3[1].split('&')
      let dateEndEncoded = arrayDate4[0]
      // rempklace les encodages date debut
      let dateStart2 = dateStartEncoded.replace(deuxPoints, ':')
      let dateStart3 = dateStart2.replace(plus, '+')
      // rempklace les encodages date fin
      let dateEnd2 = dateEndEncoded.replace(deuxPoints, ':')
      let dateEnd3 = dateEnd2.replace(plus, '+')
      // console.log('dateStart', dateStart3)
      // console.log('dateEnd', dateEnd)
      // console.log('dateStart : ', Number(moment.parseZone(dateStart3).format('X')))
      // les dtae correctement encodaé pour passer dans moment
      let dateStart = Number(moment.parseZone(dateStart3).format('X'))
      let dateEnd = Number(moment.parseZone(dateEnd3).format('X'))
      // retourne le nombres de jours dans la périodes selectionnée
      this.joursPeriode = Math.round((((dateEnd - dateStart) / 60) / 60) / 24)

      // console.log('calculPeriodeConnexion', this.params)
      // console.log('this.agents.length', this.agents.length)
      let arrayParams = this.params.split('agentsId=')
      let arrayAgentIdSelected = arrayParams[1].split(',')
      this.tempsPresence = 0
      let tempsTotalJour = 0
      // console.log('this.agents.length', this.agents.length)
      // console.log('liste id agent ', arrayAgentIdSelected)
      for (let a = 0; a < this.agents.length; a++) {
        // console.log('this.agents', this.agents[a].id)
        for (let b = 0; b < arrayAgentIdSelected.length; b++) {
          // console.log('toto', arrayAgentIdSelected[b])
          if (this.agents[a].id === arrayAgentIdSelected[b]) {
            // console.log('trouvé', this.agents[a].joursHebdo)
            this.tempsPresence = this.tempsPresence + (this.agents[a].tempsTravail * this.agents[a].joursHebdo)
            console.log('this.agents[a].tempsTravail', this.agents[a].tempsTravail)
            console.log('this.agents[a].joursHebdo', this.agents[a].joursHebdo)
            console.log('tempsPresence', this.tempsPresence)
            console.log('tempsTotalJour', tempsTotalJour)
            tempsTotalJour = tempsTotalJour + Number(this.agents[a].tempsTravail)
            // let data = {
            //   'id': this.agents[a].id,
            //   'h': ((this.agents[a].tempsTravail * 60) * 60)
            // }
            // tableau des heures de travail par agent
            this.agentsHeures.push(this.agents[a].tempsTravail)
          }
        }
      }
      // -------------------------------------
      // Il faut revoir le calcul du temps total
      // total temps de travail sur la période pour tous les agent
      this.totalTempsPeriode = ((((this.joursPeriode / 7) * this.tempsPresence) * 60) * 60) // en secondes
      console.log('temps total de travail hebdomadaire pour tous les agents selectionnés ', this.tempsPresence)
      console.log('temps total temps de travail  pour tous les agents selectionnés sur la période', this.totalTempsPeriode)
    },

    openOccupation (data) {
      // console.log('openOccupation', data)
      // console.log(' this.agents', this.agents)
      // console.log('data.point.options.agentID', data.point.options.agentID)
      // console.log('dateStart : ', Number(moment.parseZone(this.GET_DATESTART).format('X')))
      // console.log('dateEnd : ', Number(moment.parseZone(this.GET_DATEEND).format('X')))
      let tempsTravailJour = 0
      let joursSemaine = 0
      for (let a = 0; a < this.agents.length; a++) {
        // console.log('toto', arrayAgentIdSelected[b])
        if (Number(this.agents[a].id) === data.point.options.agentID) {
          // console.log('this.agents[a]', this.agents[a])
          tempsTravailJour = this.agents[a].tempsTravail
          joursSemaine = this.agents[a].joursHebdo
        }
      }
      // let indexDate = data.point.index
      // console.log('date : ', data.point.series.userOptions.day[indexDate])
      // console.log('date seleted ', data.point.series.userOptions.arrayDays[indexDate].date)
      let dateStart = Number(moment.parseZone(this.GET_DATESTART).format('X'))
      let dateEnd = Number(moment.parseZone(this.GET_DATEEND).format('X'))
      let agentID = data.point.options.agentID
      this.dataAgentSelected.dateStart = dateStart
      this.dataAgentSelected.dateEnd = dateEnd
      this.dataAgentSelected.agentID = agentID
      this.dataAgentSelected.agentName = data.point.options.name
      this.dataAgentSelected.agentColor = data.point.color
      this.dataAgentSelected.tempsTravail = tempsTravailJour
      this.dataAgentSelected.joursHebdo = joursSemaine
      this.occupationAgentPeriode = true
    },

    /**
     * Ouvre l'occupation d'un agent à la journée selectionné
     */
    openDayOccupation (data) {
      console.log('data user : ', data)
      let tempsTravailJour = 0
      let joursSemaine = 0
      for (let a = 0; a < this.agents.length; a++) {
        // console.log('toto', arrayAgentIdSelected[b])
        if (Number(this.agents[a].id) === data.point.series.userOptions.agentID) {
          // console.log('this.agents[a]', this.agents[a])
          tempsTravailJour = this.agents[a].tempsTravail
          joursSemaine = this.agents[a].joursHebdo
        }
      }
      // console.log('date (category) : ', data.point.category)
      // console.log('agent id : ', data.point.series.userOptions.agentID)
      // console.log('agent name : ', data.point.series.userOptions.name)
      let indexDate = data.point.index
      // console.log('date : ', data.point.series.userOptions.day[indexDate])
      // console.log('date seleted ', data.point.series.userOptions.arrayDays[indexDate].date)
      let dateStart = Number(moment.parseZone(data.point.series.userOptions.arrayDays[indexDate].date).format('X'))
      let dateEnd = dateStart + 86400
      // console.log('dateStart', dateStart)
      // console.log('dateEnd', dateEnd)
      let agentID = data.point.series.userOptions.agentID
      this.dataAgentSelected.dateStart = dateStart
      this.dataAgentSelected.dateEnd = dateEnd
      this.dataAgentSelected.agentID = agentID
      this.dataAgentSelected.agentName = data.point.series.name
      this.dataAgentSelected.agentColor = data.point.color
      this.dataAgentSelected.tempsTravail = tempsTravailJour
      this.dataAgentSelected.joursHebdo = joursSemaine
      // console.log('dateStart : ', dateStart)
      this.occupationAgentDay = true
    },

    /**
     * Ouvre les plages de presence agents pour la journée
     */
    openPresenceAgents (data) {
      console.log('this.agents', this.agents)
      let indexDate = data.point.index
      this.dataAgentsSelected.agents = [] // vide le tableau
      // let tempsTravailJour = 0
      // let joursSemaine = 0
      let numAgents = data.point.series.userOptions.dataAgents[indexDate].agents.length
      if (numAgents) {
        for (let a = 0; a < this.agents.length; a++) {
          // console.log('toto', arrayAgentIdSelected[b])
          for (let i = 0; i < numAgents; i++) {
            if (Number(this.agents[a].id) === data.point.series.userOptions.dataAgents[indexDate].agents[i]) {
              // console.log('this.agents[a]', this.agents[a])
              this.dataAgentsSelected.agents.push(this.agents[a])
            }
          }
        }
      }
      let dateStart = Number(moment.parseZone(data.point.series.userOptions.dataAgents[indexDate].date).format('X'))
      let dateEnd = dateStart + 86400
      this.dataAgentsSelected.dateStart = dateStart
      this.dataAgentsSelected.dateEnd = dateEnd
      // this.dataAgentsSelected.agentID = data.point.series.userOptions.dataAgents[indexDate].agents
      console.log('dataAgentsSelected', this.dataAgentsSelected)
      this.presenceAgentsDay = true
    },

    getAgentsOccupation () {
      // let returnHorraire = this.returnListeHeure()
      let ref = this.agentsHeures.join() // transforme le tableau en chaine
      console.log('ref', ref)
      let parametres = this.params + '&refTime=' + ref
      // console.log('parametres', parametres)
      this.axios.get('get/occupationAgentsPeriode.php?' + parametres)
      .then(response => {
        // console.log('getAgentsOccupation response', response)
        this.totalTempsAllChats = response.data.totalTempsAllChats // en secondes
        this.tempsOccupationPartielle = response.data.tempsOccupationPartielle // en secondes
        this.tempsOccupationBusy = response.data.tempsOccupationBusy // en secondes
        this.moyenChatMax = response.data.moyenChatMax
        this.moyenChatHeure = response.data.chatParHeure
      })
      .catch()
      .then(_ => {
        // this.loading = false
        this.getConnexions()
        // this.occupationAgentDay = true
      })
    },
    /**
     * lance toutes les requêtes
     */
    getConnexions () {
      let ref = this.agentsHeures.join() // transforme le tableau en chaine
      // console.log('ref', ref)
      let parametres = this.params + '&refTime=' + ref
      // console.log('parametres', parametres)
      this.axios.get('get/connexionAgentsPeriode.php?' + parametres)
      .then(response => {
        // console.log('response : ', response)
        this.totalTempsConnexion = response.data.totalTempsConnexion
      })
      .catch()
      .then(_ => {
        // this.loading = false
        // this.occupationAgentDay = true
        // charge les status agent
        this.getStatusAgent()
      })
    },

    /**
     * lance la requête statusAgentDay
     */
    getStatusAgent () {
      this.loadingActivity = true
      this.axios.get('get/statusAgentsPeriode.php?' + this.params)
      .then(response => {
        // this.activityAgent.series = []
        // this.activityAgent.xAxis.categories = []
        // console.log('response : ', response)
        this.totalTempsPresence = response.data.totalTempsPresence // en seconde
        this.tempsTotalOnline = response.data.tempsTotalOnline // en secondes
        this.tempsTotalBusy = response.data.tempsTotalBusy // en secondes
        // console.log('tempsTotalOnline', this.tempsTotalOnline)
        // console.log('tempsTotalBusy', this.tempsTotalBusy)
        let total = this.tauxOccupationPartiel + this.tauxBusy + this.tauxInoccupation
        let taux1 = (this.tauxOccupationPartiel * 100) / total
        let taux2 = (this.tauxBusy * 100) / total
        let taux3 = (this.tauxInoccupation * 100) / total
        let dataOccupation = [
          {
            name: _.upperFirst(this.$t('partialOccupation')),
            color: this.optionsGraph.colors[9],
            y: this.tauxOccupationPartiel,
            val: taux1
          },
          {
            name: _.upperFirst(this.$t('maximumOccupancy')),
            color: this.optionsGraph.colors[15],
            y: this.tauxBusy,
            val: taux2
          },
          {
            name: _.upperFirst(this.$t('unoccupied')),
            color: this.optionsGraph.colors[10],
            y: this.tauxInoccupation,
            val: taux3
          }
        ]
        // console.log('dataOccupation', dataOccupation)
        this.activityAgent.series = [{}]
        this.activityAgent.series[0].data = []
        // this.activityAgent.series[0].data[0] = dataOccupation
        this.activityAgent.series[0].data = dataOccupation

        // données pour les taux d'occupation agent
        let dataTauxOccupation = [
          {
            type: 'area',
            name: _.upperFirst(this.$t('offline')),
            color: this.optionsGraph.colors[0],
            data: response.data.arrayTauxOffline,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ' %'
            }
          },
          {
            type: 'area',
            name: _.upperFirst(this.$t('online')),
            color: this.optionsGraph.colors[10],
            data: response.data.arrayTauxOnline,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ' %'
            }
          },
          {
            type: 'area',
            name: _.upperFirst(this.$t('busy')),
            color: this.optionsGraph.colors[15],
            data: response.data.arrayTauxBusy,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ' %'
            }
          },
          {
            // type: 'column',
            type: 'line',
            yAxis: 1,
            name: _.upperFirst(this.$t('statSuperv16')),
            color: 'rgba(63, 81, 181, 0.6)',
            // color: this.optionsGraph.colors[4],
            data: this.moyenChatHeure,
            tooltip: {
              split: true,
              // shared: true,
              valueSuffix: ''
            }
          }
        ]
        this.tauxActivityAgent.series = dataTauxOccupation
        // ajout des données dans l'axe des Y
        // this.tauxActivityAgent.series[0].data.push(response.data.arrayTauxOffline)
        // this.tauxActivityAgent.series[1].data.push(response.data.arrayTauxOnline)
        // this.tauxActivityAgent.series[2].data.push(response.data.arrayTauxBusy)
        // this.activityAgent.series.totalTempsActivity = this.afficheTotalTempsPresence
        // this.agentsChatsBar.series.push({
        // this.activityAgent.series.totalTempsActivity = this.afficheTotalTempsPresence
      })
      .catch()
      .then(_ => {
        // this.occupationAgentDay = true
        // charge les status agent
        // this.getStatusAGent()
        // calcule l'activité en poucentage
        // % de presence / (par le nombre de jours de la période selectionnée)
        // console.log('this.totalTempsConnexion', this.totalTempsConnexion)
        // console.log('this.tempsPresence', this.tempsPresence)
        // console.log('joursPeriode', this.joursPeriode)
        // console.log('this.tempsTotalBusy', this.tempsTotalBusy)
        // console.log('this.tempsTotalOnline', this.tempsTotalOnline)
        // console.log('afficheTotalTempsActivity', this.afficheTotalTempsActivity)
        // temps total online + busy
        let totalActivityTime = (this.tempsTotalBusy + this.tempsTotalOnline)
        // console.log('totalActivityTime', totalActivityTime)
        let presence = (this.totalTempsConnexion * 100) / this.totalTempsPeriode
        this.tauxProductivity1 = presence.toFixed(2)
        console.log('tauxProductivity1', this.totalTempsConnexion, this.totalTempsPeriode)
        this.graphProductivityAgent.series[0].data[0].y = Math.round(presence * 100) / 100
        // % d'activité chat
        // il faut diviser ce nombre par le nombre de chat max dispo pour cet agent
        // console.log('totalActivityTime', totalActivityTime)
        let totalChats = (totalActivityTime * 100) / this.totalTempsPeriode
        this.tauxProductivity2 = totalChats.toFixed(2)
        this.graphProductivityAgent.series[1].data[0].y = Math.round(totalChats * 100) / 100
        // % d'inactivité
        let inactiv = ((this.totalTempsConnexion - totalActivityTime) * 100) / this.totalTempsPeriode
        this.tauxProductivity3 = inactiv.toFixed(2)
        this.graphProductivityAgent.series[2].data[0].y = Math.round(inactiv * 100) / 100
        // console.log('this.productivityAgent', totalActivityTime + '-' + this.totalTempsAllChats)
        this.loadingActivity = false
      })
    },

    /**
     * Récupère les chats par agents
     */
    getAgentsChats () {
      this.loadingAgentsChats = true
      this.axios.get('get/agents_chats.php?' + this.params)
      .then(response => {
        // mise à jour du graphique avec les données récupérées
        // reset des data du graphique
        this.agentsChatsPie.series = [{}]
        this.agentsChatsPie.series[0].data = []
        this.agentsChatsBar.series = []
        this.agentsChatsBar.xAxis.categories = []
        // Maj du camembert (part des chats/agent)
        // et ajout des series pour les agents du graph colonnes
        let idAgents = []
        let nbChats = 0
        response.data.chatsByAgent.forEach(agent => {
          // change l'id par le nom de l'agent parmis les agents sélectionné
          let agentFound = _.find(this.$store.state._User.colleagues, {'USR_ID': _.toString(agent.id)})
          this.agentsChatsPie.series[0].data.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            y: agent.pourcent,
            chats: agent.nb
          })
          // incrémentation du nombre de chat totaux
          nbChats += agent.nb
          idAgents.push(agent.id)
          this.agentsChatsBar.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            data: []
          })
        })
        // Maj du titre indiquant le total de chats
        this.agentsChatsPie.title.text = _.upperFirst(this.$tc('distributionOfChats', 1, {count: nbChats}))
        // Maj des colonnes stackées (data par jour)
        // pour chaque jour
        Object.entries(response.data.days).forEach(([date, agents]) => {
          // ajout des jours dans l'axe des X
          this.agentsChatsBar.xAxis.categories.push(moment(date).format('ddd D MMM YY'))
          // ajout des données dans l'axe des Y
          // pour chaque agent
          Object.entries(agents).forEach(([id, chat]) => {
            let idx = idAgents.findIndex(i => i === _.toNumber(id))
            if (idx !== -1 && this.agentsChatsBar.series[idx]) {
              this.agentsChatsBar.series[idx].data.push(chat)
            }
          })
        })
        console.log('this.agentsChatsBar', this.agentsChatsBar)
      })
      .catch()
      .then(_ => {
        this.loadingAgentsChats = false
      })
    },
    /**
     * Récupère le taux d'activité des agents
     */
    // **************** A SUPPRIMER ***************** //
    /*
    getAgentsActivity () {
      this.loadingAgentsActivity = true
      this.axios.get('get/agents_activity.php?' + this.params)
      .then(response => {
        // mise à jour du graphique avec les données récupérées
        // reset des data du graphique
        this.agentsActivity.xAxis.categories = []
        this.agentsActivity.series[0].data = []
        this.agentsActivity.series[1].data = []
        this.agentsActivity.series[2].data = []
        // Maj des colonnes stackées (data par jour)
        _.each(response.data.activity, (values, date) => {
          // ajout des jours dans l'axe des X
          this.agentsActivity.xAxis.categories.push(
            moment(date).format('ddd D MMM YY')
            // moment(date).format('x')
          )
          // ajout des données dans l'axe des Y
          this.agentsActivity.series[0].data.push(values.pres)
          this.agentsActivity.series[1].data.push(values.conv)
          this.agentsActivity.series[2].data.push(values.taux)
        })
      })
      .catch()
      .then(_ => {
        this.loadingAgentsActivity = false
      })
    },
    */

    /**
     * Récupère la presence des agents
     */
    getAgentsPresence () {
      this.loadingAgentsPresence = true
      this.axios.get('get/presenceAgentsPeriode.php?' + this.params)
      .then(response => {
        // console.log('response présence', response)
        // mise à jour du graphique avec les données récupérées
        // reset des data du graphique
        this.agentsPresence.xAxis.categories = []
        this.agentsPresence.series[0].data = []
        this.agentsPresence.series[0].dataAgents = []
        // les couleurs
        this.agentsPresence.series[0].color = this.optionsGraph.colors[4]
        this.agentsPresence.series[1].color = this.optionsGraph.colors[2]
        this.agentsPresence.series[2].color = this.optionsGraph.colors[13]
        // Maj des colonnes stackées (data par jour)
        _.each(response.data.arrayDays, (values, idx) => {
          // ajout des jours dans l'axe des X
          this.agentsPresence.xAxis.categories.push(
            moment(values.date).format('ddd D MMM YY')
            // moment(date).format('x')
          )
        })
        _.each(response.data.nbAgentsConnected, (values, idx) => {
          // ajout des jours dans l'axe des X
          // console.log('values', values.length)
          if (values.length) {
            let obj = {
              'date': response.data.arrayDays[idx].date,
              'agents': values
            }
            this.agentsPresence.series[0].data.push(values.length)
            this.agentsPresence.series[0].dataAgents.push(obj)
          } else {
            let arr = Object.values(values)
            // this.agentsPresence.series[1].data.push(arr)
            let obj = {
              'date': response.data.arrayDays[idx].date,
              'agents': arr
            }
            let sizeArr = arr.length
            this.agentsPresence.series[0].data.push(sizeArr)
            this.agentsPresence.series[0].dataAgents.push(obj)
          }
          // this.agentsPresence.xAxis.categories.push(
          //   moment(values.date).format('ll')
          //   // moment(date).format('x')
          // )
        })
        // console.log('agents : ', this.agentsPresence.series[1].data)
        // this.agentsPresence.series[0].data = response.data.nbAgentsConnected
      })
      .catch()
      .then(_ => {
        // recupere l'audience de la période
        this.getAudienceData()
      })
    },

    getAudienceData () {
      this.loading = true
      // execution de la requête en fonction des filtres
      this.axios.get('get/audience.php?' + this.params)
      .then(response => {
        console.log('response audience', response)
        let resAudienceFromAjax = response.data
        this.agentsPresence.series[1].data = []
        this.agentsPresence.series[2].data = []
      // this.options.series[2].data = []
      // parcours le tableau des infos dans la réponse
      // if (this.interval.value === 1) { // par jour
        _.forEach(resAudienceFromAjax, day => {
          // this.agentsPresence.xAxis.categories.push(moment(day.date).format('ddd D MMM YY'))
          this.agentsPresence.series[1].data.push(day.loads)
          this.agentsPresence.series[2].data.push(day.visitors)
          // this.options.series[2].data.push(day.chats)
        })
      // } else { // par mois
        _.forEach(this.resAudienceFromAjax, day => {
          // vérifie que le mois du jour parcouru n'est pas déjà présent dans le tableau des x
          let found = -1
          for (var i = 0; i < this.options.xAxis.categories.length; i++) {
            if (this.options.xAxis.categories[i] === moment(day.date).format('MMMM YYYY')) {
              found = i
            }
          }
          if (found === -1) {
            // ajout du mois dans le tableau des x
            this.options.xAxis.categories.push(moment(day.date).format('MMMM YYYY'))
            this.agentsPresence.series[1].data.push(day.loads)
            this.agentsPresence.series[2].data.push(day.visitors)
            // this.options.series[2].data.push(day.chats)
          }
          // ajout des valeurs dans le mois correspondant
          this.agentsPresence.series[1].data[found] += day.loads
          this.agentsPresence.series[2].data[found] += day.visitors
          // this.agentsPresence.series[2].data[found] += day.chats
        })
      // }
      // type de graphique en fonction du nombre de jour de l'intervalle
      // if (this.$parent.nbDays === 1 || this.interval.value !== 1) {
      //   this.agentsPresence.series[1].type = 'column'
      //   this.agentsPresence.series[2].type = 'column'
      // } else {
        // this.agentsPresence.series[1].type = 'area'
        // this.agentsPresence.series[2].type = 'area'
      // }
      })
      .catch(errors => {})
      .then(_ => {
        this.loadingAgentsPresence = false
      })
    },

    exportAgentsChatsPie () {
      let csv = ''
      let data = []
      let fields = ['name', 'chats', 'y']
      let fieldNames = ['agent', 'chats', 'pourcentage']
      data = this.agentsChatsPieComputed
      // console.log('data', data)
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsChatsPie.csv', csv)
    },
    exportProductivity () {
      let csv = ''
      let data = []
      let fields = ['connexion', 'activity', 'inactivity']
      let fieldNames = ['taux de connexion', 'taux d\'activité', 'taux d\'inactivité']
      let values = {
        connexion: this.tauxProductivity1,
        activity: this.tauxProductivity2,
        inactivity: this.tauxProductivity3
      }
      data.push(values)
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsProductivity.csv', csv)
    },
    exportAgentsOccupation () {
      let csv = ''
      let data = []
      let fields = ['partielle', 'maximum', 'inoccupe']
      let fieldNames = [this.$t('statSuperv18'), this.$t('statSuperv19'), this.$t('statSuperv20')]
      // let values = {}
      // console.log(this.activityAgent.series)
      // _.each(this.activityAgent.series[0].data, (val, i) => {
        // values[s.name] = s.data[k]
        // console.log('value', val)
      // })
      let values = {
        partielle: this.activityAgent.series[0].data[0].val.toFixed(2),
        maximum: this.activityAgent.series[0].data[1].val.toFixed(2),
        inoccupe: this.activityAgent.series[0].data[2].val.toFixed(2)
      }
      data.push(values)
      // console.log('data', data)
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsOccupation.csv', csv)
    },
    exportStatut () {
      let csv = ''
      let data = []
      let fields = ['date', ..._.map(this.tauxActivityAgent.series, s => s.name)]
      let fieldNames = ['dates', ..._.map(this.tauxActivityAgent.series, s => s.name)]
      _.each(this.tauxActivityAgent.xAxis.categories, (date, k) => {
        let values = {
          date: date
        }
        _.each(this.tauxActivityAgent.series, (s, i) => {
          values[s.name] = s.data[k]
        })
        data.push(values)
      })
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsStatut.csv', csv)
    },
    exportAgentsChatsBar () {
      let csv = ''
      let data = []
      let fields = ['date', ..._.map(this.agentsChatsBar.series, s => s.name)]
      let fieldNames = ['dates', ..._.map(this.agentsChatsBar.series, s => s.name)]
      _.each(this.agentsChatsBar.xAxis.categories, (date, k) => {
        let values = {
          date: date
        }
        _.each(this.agentsChatsBar.series, (s, i) => {
          values[s.name] = s.data[k]
        })
        data.push(values)
      })
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsChatsBar.csv', csv)
    },
    /*
    exportAgentsActivity () {
      let csv = ''
      let data = []
      let fields = ['date', 'presence', 'conversation', 'activity']
      let fieldNames = ['date', 'presence', 'conversation', 'activity']
      _.each(this.agentsActivity.xAxis.categories, (date, k) => {
        let values = {
          date: date,
          presence: this.agentsActivity.series[0].data[k],
          conversation: this.agentsActivity.series[1].data[k],
          activity: this.agentsActivity.series[2].data[k]
        }
        data.push(values)
      })
      try {
        csv = json2csv({ data, fields, del: ';', fieldNames })
      } catch (err) {
        return
      }
      this.downloadFile('agentsActivity.csv', csv)
    },
    */
    downloadFile (filename, content) {
      let hiddenElement = document.createElement('a')
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content)
      hiddenElement.target = '_blank'
      hiddenElement.download = filename
      document.body.appendChild(hiddenElement)
      hiddenElement.click()
    },

    dialogOccupationRemove () {
      this.occupationAgentDay = false
    },

    dialogOccupationPeriodeRemove () {
      this.occupationAgentPeriode = false
    },

    dialogPresenceDayRemove () {
      this.presenceAgentsDay = false
    }
  },
  watch: {
    params (v) {
      this.getAll()
    }
  }
}
</script>
<style>
.v-expansion-panel__header {margin-left: 16px;}
.v-input--slider {margin-bottom: 20px; margin-top: 0px !important;}
/*.btn_copierBulleChat{margin:0; position: absolute; top: 12px; right: 6px;}*/
</style>



// WEBPACK FOOTER //
// src/components/stats/AgentsPerformance.vue